export class DarkModeConfig {
  activeTheme!: any;
}
